import type Entry from 'garaje/models/entry';
import type Invite from 'garaje/models/invite';

/**
 * True when the guest's ID scan flagged a name mismatch that has since been
 * resolved (approved or denied). Does not check the feature flag; callers gate on
 * the `id-name-mismatch-screener` split separately.
 */
export default function isResolvedIdNameMismatch(model: Entry | Invite): boolean {
  const result = model.visitApproval?.idScanningResult;
  if (!result?.isIdScanning()) return false;
  return Boolean(result.report['name-match']?.mismatch && (result.isApproved || result.isDenied));
}
